export default __webpack_public_path__ + "media/plus/manage-visual-2f3308d5.svg";